export default "<a type=\"button\" [attr.class]=\"cssClass\" [class.disabled]=\"!enabled\" (click)=\"onButtonClick()\"></a>\n"